import React from 'react';

import { EDarkModeSettings, useDarkMode } from '@/hooks/useDarkMode';
import CheckIcon from '@material-ui/icons/Check';

import { AccountDisplayProps } from '../AccountPanel';
import { SettingsList, SettingsListItems } from '@/components/shared/SettingCard';
import styles from './SettingDarkMode.module.scss';

export const SettingDarkMode: React.FC<AccountDisplayProps> = () => {
	const { darkModeSetting, setDarkModeSetting } = useDarkMode();

	const items: SettingsListItems = [
		{
			type: 'setting',
			title: 'On',
			onClick: () => setDarkModeSetting(EDarkModeSettings.ON),
			trailingComponent: darkModeSetting === EDarkModeSettings.ON ? <CheckIcon /> : <></>,
			noChevron: true,
		},
		{
			type: 'setting',
			title: 'Off',
			onClick: () => setDarkModeSetting(EDarkModeSettings.OFF),
			trailingComponent: darkModeSetting === EDarkModeSettings.OFF ? <CheckIcon /> : <></>,
			noChevron: true,
		},
		{
			type: 'setting',
			title: 'Use system settings',
			subtitle: "Use your device's system appearance setting for light mode, dark mode or automatic themes.",
			onClick: () => setDarkModeSetting(EDarkModeSettings.SYSTEM),
			trailingComponent: darkModeSetting === EDarkModeSettings.SYSTEM ? <CheckIcon /> : <></>,
			noChevron: true,
		},
	];

	return (
		<div className={styles['setting-dark-mode']}>
			<SettingsList items={items} />
		</div>
	);
};
